<template>
  <div
    class="page-content-sidebar-list-title"
    :class="{
      'page-content-sidebar-list-title_margin-top': !resetMarginTop,
      'page-content-sidebar-list-title--dark': dark,
    }"
    :style="{ paddingLeft: paddingLeft || paddingX, paddingRight: paddingRight || paddingX }"
  >
    <slot name="title">
      <span>{{ title }}</span>
    </slot>
    <slot name="icon">
      <tm-button
        v-if="showAddButton"
        icon-only
        size="small"
        class="page-content-sidebar-list-title__add-btn"
        :class="{ 'page-content-sidebar-list-title__add-btn--dark': dark }"
        color="transparent"
        flat
        @click="$emit('add-btn-click')"
      >
        <tm-icon name="add" />
      </tm-button>
    </slot>
  </div>
</template>

<script setup lang="ts">
import TmButton from '@/components/shared/TmButton.vue'
import TmIcon from '@/components/shared/TmIcon.vue'
import type { StylesheetSizeProp } from '@/types'

const { paddingX = '16px' } = defineProps<{
  dark?: boolean
  title?: string
  showAddButton?: boolean
  paddingX?: StylesheetSizeProp
  paddingLeft?: StylesheetSizeProp
  paddingRight?: StylesheetSizeProp
  resetMarginTop?: boolean
}>()

defineEmits<{ 'add-btn-click': [] }>()
</script>

<style lang="scss" scoped>
.page-content-sidebar-list-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
  line-height: 18px;
  font-size: $sm-font;
  font-weight: $bold-font;
  color: $gray8;
  text-transform: uppercase;
  cursor: default;

  &--dark {
    color: $gray5;
  }

  &_margin-top {
    margin-top: 8px;
  }
  &__add-btn {
    margin: -6px -8px -6px 0;
    &:not(:hover) {
      background-color: transparent !important;
    }
    &--dark {
      color: $light !important;
      &:hover:not([disabled]) {
        background-color: $neutral !important;
      }
    }
  }
  .tm-icon {
    font-weight: $semi-bold-font;
  }
}
</style>
